// Legend as wrapping chips — pass as `<Legend content={<ChartLegend />} />`.
// Recharts' default legend is a single inline row that overflows on a phone;
// chips wrap onto new lines (Recharts measures the rendered height and gives
// the plot the rest), use the micro type size and the series colour swatch.

import type { LegendPayload } from "recharts";

export function ChartLegend({ payload }: { payload?: ReadonlyArray<LegendPayload> }) {
  const items = (payload ?? []).filter((p) => p.type !== "none");
  if (items.length === 0) return null;
  return (
    <ul className="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 pt-2" aria-label="Series">
      {items.map((p, i) => (
        <li
          key={`${String(p.dataKey ?? p.value)}-${i}`}
          className={`inline-flex h-6 items-center gap-1.5 rounded-md border border-line bg-surface-2/60 px-2 text-[11px] leading-4 text-text-2 ${p.inactive ? "opacity-50" : ""}`}
        >
          <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: p.color }} aria-hidden="true" />
          <span className="whitespace-nowrap">{String(p.value)}</span>
        </li>
      ))}
    </ul>
  );
}
